export class OutgoingFaxTask {
  constructor(task) {
    this.id = task.id;
    this.description = task.description;
    this.toFaxNumber = task.toFaxNumber;
    this.fromFaxNumber = task.fromFaxNumber;
    this.fileLinks = task.fileLinks;
    this.status = task.status;
    this.statusModifiedOn = task.statusModifiedOn ? new Date(task.statusModifiedOn) : null;
    this.createdOn = task.createdOn ? new Date(task.createdOn) : null;
    this.modifiedOn = task.modifiedOn ? new Date(task.modifiedOn) : null;
  }
}
